import { render, staticRenderFns } from "./hearing-test.vue?vue&type=template&id=6beb90a7&scoped=true&"
import script from "./hearing-test.vue?vue&type=script&lang=js&"
export * from "./hearing-test.vue?vue&type=script&lang=js&"
import style0 from "./hearing-test.vue?vue&type=style&index=0&id=6beb90a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb90a7",
  null
  
)

export default component.exports